export default "__VITE_ASSET__5e917693__"